module.exports = __webpack_public_path__ + "static/media/rim_01.2369df53.wav";